import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Button } from "../../../../../components/UI/Button";
import TextInput from "../../../../../components/UI/TextInput";
import Modal from "../../../../../components/UI/Modal";
import Selection from "../../../../../components/UI/Selection";
import { useAuthStore } from "../../../../../stores/auth-store";
import { companyShopUseCase } from "../../../../../../di/container";
import { onError } from "../../utils";

interface NewBannerFormProps {
  setIsModalVisible: React.Dispatch<React.SetStateAction<boolean>>;
  isModalVisible: boolean;
  reloadBannersData: () => void;
}

export const NewBannerForm = ({
  setIsModalVisible,
  isModalVisible,
  reloadBannersData,
}: NewBannerFormProps) => {
  const { user } = useAuthStore();

  interface NewBannerForm {
    bannerImage: FileList;
    actionType: "PRODUCT" | "NOTICE" | "FAQ" | "CUSTOM" | "NONE";
    actionValue: string;
    name: string;
  }
  const newBannerForm = useForm<NewBannerForm>({
    defaultValues: {
      actionType: "NONE",
    },
  });

  const newBannerFormBannerWatch = newBannerForm.watch("bannerImage");
  const newBannerFormBannerPreviewUrl =
    newBannerFormBannerWatch && newBannerFormBannerWatch.length > 0
      ? URL.createObjectURL(newBannerFormBannerWatch[0])
      : "";

  const onNewBannerFormSubmit = async (data: NewBannerForm) => {
    const file =
      data.bannerImage && data.bannerImage.length > 0
        ? data.bannerImage[0]
        : undefined;

    if (user?.companyId && file) {
      await companyShopUseCase.createBanner({
        companyId: user?.companyId,
        bannerFile: file,
        command: {
          title: data.name,
          actionType: data.actionType,
          actionValue: data.actionType === "NONE" ? null : data.actionValue,
        },
      });
    }

    reloadBannersData();
    newBannerForm.reset();
    setIsModalVisible(false);
  };

  const [selectedOption, setSelectedOption] = useState<string>("NONE");
  useEffect(() => {
    switch (selectedOption) {
      case "NONE":
        newBannerForm.setValue("actionType", "NONE");
        break;
      case "PRODUCT":
        newBannerForm.setValue("actionType", "PRODUCT");
        break;
      case "NOTICE":
        newBannerForm.setValue("actionType", "NOTICE");
        break;
      case "FAQ":
        newBannerForm.setValue("actionType", "FAQ");
        break;
      case "CUSTOM":
        newBannerForm.setValue("actionType", "CUSTOM");
        break;
      default:
        break;
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedOption]);

  return (
    <>
      {isModalVisible && (
        <Modal setIsModalVisible={setIsModalVisible} title="">
          <form
            onSubmit={newBannerForm.handleSubmit(
              onNewBannerFormSubmit,
              onError,
            )}
          >
            <div className="w-[calc(100vw-20vw)] max-w-[31.875rem]">
              <div className="flex flex-col items-start mb-[1.0625rem]">
                <h2 className="mb-[0.75rem]">새 배너 추가</h2>
              </div>

              <label>
                <div
                  className="relative w-full h-[150px] mb-[1.0625rem] outline-dashed outline-gray-200
            flex justify-center items-center text-gray-300"
                >
                  <div className="absolute">이미지를 업로드해주세요.</div>
                  {newBannerFormBannerPreviewUrl && (
                    <img
                      className="relative z-30 h-full"
                      src={newBannerFormBannerPreviewUrl}
                      alt="프리뷰 이미지"
                    />
                  )}
                </div>

                <input
                  type="file"
                  className="text-start hidden"
                  accept=".png,.jpg,.jpeg,.pdf"
                  {...newBannerForm.register("bannerImage", {
                    required: {
                      value: true,
                      message: "필수 항목이에요.",
                    },
                  })}
                />
              </label>

              <div className="text-start mb-[1.0625rem]">
                <label className="block text-sm font-medium mb-2">이름</label>
                <TextInput
                  {...newBannerForm.register("name", {
                    required: {
                      value: true,
                      message: "필수 항목이에요.",
                    },
                  })}
                  error={{
                    message: newBannerForm.formState.errors.name?.message || "",
                    isIconVisible: true,
                    isMessageVisible: true,
                  }}
                  placeholder="배너 이름 입력"
                  className="bg-gray-50"
                />
              </div>

              <div className="h-[45px] text-start mb-[40px]">
                <label className="block text-sm font-medium mb-[6px]">
                  액션 타입
                </label>
                <Selection
                  selectedOption={selectedOption}
                  setSelectedOption={setSelectedOption}
                  options={[
                    { value: "NONE", name: "없음" },
                    { value: "PRODUCT", name: "상품" },
                    { value: "NOTICE", name: "공지사항" },
                    { value: "FAQ", name: "자주 묻는 질문" },
                    { value: "CUSTOM", name: "커스텀" },
                  ]}
                ></Selection>
              </div>

              {!(selectedOption === "NONE") ? (
                <div className="text-start mb-[1.0625rem]">
                  <label className="block text-sm font-medium mb-2">
                    액션 URL
                  </label>
                  <TextInput
                    {...newBannerForm.register("actionValue", {})}
                    error={{
                      message:
                        newBannerForm.formState.errors.actionValue?.message ||
                        "",
                      isIconVisible: true,
                      isMessageVisible: true,
                    }}
                    placeholder="배너 액션 URL"
                    className="bg-gray-50"
                  />
                </div>
              ) : null}

              <div className="relative">
                <div className="absolute top-0 bottom-0 left-0 right-0 mx-[-19px] bg-[#F9FAFB] outline outline-1 outline-[#E5E7EB] rounded-b-[12px]"></div>
                <div className="relative z-50 flex flex-row justify-end py-[1rem] mb-[-20px] items-center">
                  <div>
                    <Button className="w-[4.014375rem] h-[2.5625rem]">
                      완료
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </Modal>
      )}
    </>
  );
};
